import { Link, useLocation } from "react-router-dom";
import ThemeMaker from "../../components/thememaker";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../utils/config";
import { toast } from "react-toastify";
import { Tag } from 'antd';

const VariantsList = () => {
    const { apiEndpoint, awsKeyId, awsSecretKey, awsRegion, awsBucket, baseNodeapiUrl } = config;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const productId = queryParams.get("productId")
    const product_type_id = queryParams.get("product_type_id")
    const category_id = queryParams.get("category_id")
    const [variants, setVariants] = useState([]);

    const fetchVariants = async () => {
        try {
            const response = await axios({
                url: `${apiEndpoint}/list-variant`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    product_id: productId
                }
            })
            setVariants(response?.data?.data);
            console.log("response variants ---------->", response?.data?.data);
        } catch (error) {
            console.error("Error fetching variants:", error);
        }
    }

    useEffect(() => {
        if (productId) {
            fetchVariants();
        } else {
            toast.error("Product ID is missing in the URL");
        }
    }, [])

    return (
        <ThemeMaker>
            <div
                className="p-4"
                style={{
                    background: "#f8fafc",
                    minHeight: "100vh",
                }}
            >
                {/* Header */}
                <div
                    className="d-flex justify-content-between align-items-center bg-white p-4 mb-3"
                    style={{
                        borderRadius: "20px",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    }}
                >
                    <div>
                        <h3
                            style={{
                                margin: 0,
                                fontWeight: 700,
                                color: "#0f172a",
                            }}
                        >
                            Product Variants
                        </h3>

                        <small style={{ color: "#64748b" }}>
                            Manage all product variants
                        </small>
                    </div>

                    <Link
                        to={`/addvariants?productId=${productId}&product_type_id=${product_type_id}&category_id=${category_id}`}
                        style={{ textDecoration: "none" }}
                    >
                        <button
                            style={{
                                background: "#f97316",
                                color: "#fff",
                                border: "none",
                                borderRadius: "10px",
                                padding: "10px 18px",
                                fontWeight: 600,
                                cursor: "pointer",
                            }}
                        >
                            + Add Variant
                        </button>
                    </Link>
                </div>

                {/* Table Card */}
                <div
                    className="bg-white"
                    style={{
                        borderRadius: "20px",
                        border: "1px solid #e2e8f0",
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    }}
                >
                    <div
                        style={{
                            height: "70vh",
                            overflowY: "auto",
                            overflowX: "auto",
                            borderRadius: "0 0 20px 20px",
                        }}
                    >
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                            }}
                        >
                            <thead
                                style={{
                                    background: "#f8fafc",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 10,
                                }}
                            >
                                <tr>
                                    <th
                                        className="p-3 text-start"
                                        style={{
                                            borderTopLeftRadius: "20px",
                                        }}
                                    >
                                        Image
                                    </th>
                                    <th className="p-3 text-start">ID</th>
                                    <th className="p-3 text-start">Product Name</th>
                                    <th className="p-3 text-start">GTIN</th>
                                    <th className="p-3 text-start">Attributes</th>
                                    <th
                                        className="p-3 text-center"
                                        style={{
                                            borderTopRightRadius: "20px",
                                        }}
                                    >
                                        Actions
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {variants?.map((productItem, pIndex) =>
                                    productItem?.variants?.map((item, index) => {
                                        const attributes = item.attributes || [];

                                        return (
                                            <tr
                                                key={`${pIndex}-${index}`}
                                                style={{
                                                    borderBottom: "1px solid #e2e8f0",
                                                }}
                                            >
                                                <td className="p-3">
                                                    <div
                                                        style={{
                                                            width: "70px",
                                                            height: "70px",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "12px",
                                                            overflow: "hidden",
                                                            background: "#fff",
                                                        }}
                                                    >
                                                        <img
                                                            src={item.image}
                                                            alt=""
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                            }}
                                                        />
                                                    </div>
                                                </td>

                                                <td className="p-3 fw-bold">
                                                    {item.id}
                                                </td>

                                                <td className="p-3">
                                                    <div
                                                        style={{
                                                            fontWeight: 600,
                                                            color: "#0f172a",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        {productItem?.product?.name}
                                                    </div>
                                                </td>

                                                <td className="p-3">
                                                    {item.gtin || "-"}
                                                </td>

                                                <td className="p-3">
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            gap: "6px",
                                                        }}
                                                    >
                                                        {attributes.map((attr, i) => (
                                                            <span
                                                                key={i}
                                                                style={{
                                                                    background: "#eff6ff",
                                                                    color: "#2563eb",
                                                                    borderRadius: "999px",
                                                                    padding: "5px 12px",
                                                                    fontSize: "12px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {attr.attribute_name}:{" "}
                                                                {attr.attribute_value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </td>

                                                <td className="p-3 text-center">
                                                    <Link
                                                        to={`/addvariants?variantId=${item.id}&product_type_id=${product_type_id}&category_id=${category_id}`}
                                                    >
                                                        <button
                                                            style={{
                                                                background: "#f97316",
                                                                color: "#fff",
                                                                border: "none",
                                                                borderRadius: "8px",
                                                                padding: "8px 14px",
                                                                fontWeight: 600,
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ThemeMaker>
    );
};

export default VariantsList;